import { Component, Input, OnInit, OnDestroy } from "@angular/core"
import { CHNode } from "../../../models/node.model"
import { BrowsingService } from "../../../services/browsing.service"
import { Subscription } from "rxjs"

@Component({
    selector: "app-breadcrumbs",
    templateUrl: "./breadcrumbs.component.html",
    styleUrls: ["./breadcrumbs.component.scss"],
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {
    breadcrumbs: CHNode[] = []
    subscriptions: Subscription[] = []

    constructor(private browsingService: BrowsingService) {}

    ngOnInit() {
        this.subscriptions.push(
            this.browsingService.activeNodeChanged.subscribe((node: CHNode) => {
                this.breadcrumbs = node.getTopParents()
            })
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
